export interface IBitecoinSettingsModel extends Components.Schemas.BitecoinSettingsDto { }
export interface IBitecoinSettingsParams extends Components.Schemas.UpdateBitecoinSettingsDto { }
export interface IBitecoinRewardCategoryCollectionFilter extends Paths.BitecoinControllerGetRewardCategories.QueryParameters { }
export interface IBitecoinRewardCategoryCollection extends Components.Schemas.BitecoinRewardCategoryCollectionDto { }
export interface IBitecoinRewardCategoryModel extends Components.Schemas.BitecoinRewardCategoryDto { }
export interface IBitecoinRewardCategoryCreateParams extends Components.Schemas.CreateBitecoinRewardCategoryDto { }
export interface IBitecoinRewardCategoryUpdateParams extends IBitecoinRewardCategoryCreateParams { }
export interface IBitecoinRewardCollectionFilter extends Paths.BitecoinControllerGetRewards.QueryParameters { }
export interface IBitecoinRewardCollection extends Components.Schemas.BitecoinRewardCollectionDto { }
export interface IBitecoinRewardModel extends Components.Schemas.BitecoinRewardDto { }
export interface IBitecoinRewardCreateParams extends Components.Schemas.CreateBitecoinRewardDto { }
export interface IBitecoinRewardUpdateParams extends Components.Schemas.UpdateBitecoinRewardDto { }

export enum ERewardType {
  Free = 'free',
  Discounted = 'discounted',
}

export enum ERewardTypeText {
  Free = 'Free Item',
  Discounted = 'Discounted Item',
}

export enum ECommonEntityStatus {
  Inactive = 'inactive',
  Active = 'active',
  Archived = 'archived'
}

export enum ECommonEntityStatusText {
  Inactive = 'Inactive',
  Active = 'Active',
  Archived = 'Archived'
}

export enum ERewardDiscountType {
  DiscountFix = 'discountFix',
  DiscountPercent = 'discountPercent',
}

export enum ERewardDiscountTypeText {
  DiscountFix = 'Fixed amount of peso off',
  DiscountPercent = '% off discount',
}
